<div class="h-fit bg-background flex flex-col gap-4">
    <div class="flex flex-row items-start py-8 px-4 bg-on-primary rounded-xl">
        <div class="flex flex-col w-80 pr-4">
            <app-input-text
                [additionalClasses]="'!mb-0'"
                [disabled]="
                    !entityDetailCreationContextService.isLayerEditable() ||
                    nonEditableColumnsName().includes(currentBusinessIdentifierKey() ?? '')
                "
                [inputFormControl]="currentBusinessIdentifierControl()!"
                [label]="currentBusinessIdentifierKey() ?? ''"
                [matTooltip]="nonEditableColumnsReasonByName()[currentBusinessIdentifierKey() ?? ''] ?? undefined"
                [placeholder]="currentBusinessIdentifierTitlePlaceholder()"
                (onValueChange)="updateCurrentBusinessIdentifierFromTitle($event)" />

            <div class="mt-3">
                <app-select
                    [canClear]="false"
                    [defaultValue]="defaultOptions()"
                    [isDisabled]="depositOptions().length === 1"
                    [(options)]="depositOptions"
                    (optionSelected)="selectDeposit($event)" />
            </div>
        </div>
    </div>

    @if (isLoading()) {
        <app-loading />
    } @else if (hasCurrentDeposit() && editEntityDetailService.informationSchemaTableList().length) {
        @if (!!editEntityDetailService.recomputeError()) {
            <div class="p-5 bg-on-primary rounded-xl border-solid border-2 border-error">
                <app-expansion-panel [isExpanded]="true">
                    <span
                        class="font-medium text-xl"
                        header
                        ><fa-icon
                            [class]="'text-error'"
                            [icon]="['fas', 'triangle-exclamation']" />
                        {{ 'error' | transloco: { COUNT: 1 } }}</span
                    >
                    <div
                        class="flex flex-col px-2 text-base"
                        content>
                        {{ editEntityDetailService.recomputeError() }}
                    </div>
                </app-expansion-panel>
            </div>
        }

        <div class="p-5 bg-on-primary rounded-xl">
            <app-entity-attributes
                [attributesInformations]="this.mapCreationGeomService.attributeInformationList"
                [bookmarkedAttributes]="bookmarkedAttributes()"
                [columnNamesWithReference]="columnNamesWithReference()"
                [isLayerEditable]="entityDetailCreationContextService.isLayerEditable()"
                [nonEditableColumnsName]="nonEditableColumnsName()"
                [nonEditableColumnsReasonByName]="nonEditableColumnsReasonByName()"
                [notBookmarkedAttributes]="notBookmarkedAttributes()" />
        </div>
    } @else {
        <app-no-data-to-display />
    }

    <div class="flex flex-col gap-4 justify-between p-4 bg-on-primary rounded-xl bottom-0 sticky">
        <div class="flex flex-row items-center gap-4 justify-between">
            <app-button
                [label]="'cancel' | transloco"
                [type]="ButtonType.ALERT"
                (onClick)="cancelCreation()" />

            <span>
                @if (isFromStandardizeDeposit()) {
                    <app-button
                        class="mr-2"
                        [disabled]="!entityDetailCreationContextService.isLayerEditable()"
                        [label]="'recompute' | transloco"
                        [type]="ButtonType.SECONDARY"
                        (onClick)="recompute(null)" />
                }
                <app-button
                    [disabled]="
                        !entityDetailCreationContextService.isLayerEditable() ||
                        editEntityDetailService.areFormsOnError() ||
                        !!editEntityDetailService.recomputeError()
                    "
                    [label]="'validate' | transloco"
                    [tooltip]="
                        (!!editEntityDetailService.recomputeError() ? 'editMode.recomputeErrorCorrectError' : undefined)
                            | transloco
                    "
                    [type]="ButtonType.PRIMARY"
                    (onClick)="validateEntity()" />
            </span>
        </div>
        <p class="flex items-center self-center !m-0">{{ 'attributesAutomaticallySaved' | transloco }}</p>
    </div>
</div>
